// extracted by mini-css-extract-plugin
export var container = "copy-module--container--KCqME";
export var copyContainer = "copy-module--copyContainer--NboJQ";
export var asideText = "copy-module--asideText--i29Mp";